import { AppThunk } from '../../../store/rootReducer';
import * as delineationClient from '../../delineation/clients/delineation.client';
import { updateUserDelineation } from '../../delineation/thunks/update-user-delineation.thunk';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import { waveListSelector } from '../selectors/wave.selectors';
import * as waveActions from '../actions/wave.actions';
import * as delineationActions from '../../delineation/actions/delineation.actions';
import { displayNotification } from '../../../shared/notification/display-notification';

export const saveWaves = (): AppThunk => async (dispatch, getState) => {
  const ecgId = ecgIdSelector(getState());
  const waves = waveListSelector(getState());

  if (ecgId == null) {
    return;
  }

  const success = await delineationClient.saveDelineation(ecgId, waves);

  if (success) {
    dispatch(delineationActions.markAsSaved());
    dispatch(waveActions.setSavedWaves({ waves: waves }));
    dispatch(updateUserDelineation(waves));
  } else {
    displayNotification({
      title: 'Error',
      description:
        'An error occurred, please try again or contact the support team',
      status: 'error',
    });
  }
};
